import { render, staticRenderFns } from "./ContentDetail.vue?vue&type=template&id=462b6fcc&scoped=true"
import script from "./ContentDetail.vue?vue&type=script&lang=js"
export * from "./ContentDetail.vue?vue&type=script&lang=js"
import style0 from "./ContentDetail.vue?vue&type=style&index=0&id=462b6fcc&prod&lang=scss"
import style1 from "./ContentDetail.vue?vue&type=style&index=1&id=462b6fcc&prod&lang=scss&scoped=true"
import style2 from "./ContentDetail.vue?vue&type=style&index=2&id=462b6fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b6fcc",
  null
  
)

export default component.exports